/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {SimilarCompanyState} from "./similarCompanyState.zod";

export const similarClientMatchCompanyNameScoreMin = 0;
export const similarClientMatchCompanyNameScoreMax = 100;

export const similarClientMatchWebsiteScoreMin = 0;
export const similarClientMatchWebsiteScoreMax = 100;

export const similarClientMatchOverallScoreMin = 0;
export const similarClientMatchOverallScoreMax = 100;

export const SimilarClientMatch = zod.object({
  entityType: zod.enum(["CLIENT"]),
  entityId: zod.uuid(),
  state: SimilarCompanyState,
  companyName: zod.string(),
  websiteUrl: zod.string().nullable(),
  companyNameScore: zod
    .int()
    .min(similarClientMatchCompanyNameScoreMin)
    .max(similarClientMatchCompanyNameScoreMax),
  websiteScore: zod
    .int()
    .min(similarClientMatchWebsiteScoreMin)
    .max(similarClientMatchWebsiteScoreMax)
    .nullable(),
  overallScore: zod
    .int()
    .min(similarClientMatchOverallScoreMin)
    .max(similarClientMatchOverallScoreMax),
});

export type SimilarClientMatch = zod.input<typeof SimilarClientMatch>;
export type SimilarClientMatchOutput = zod.output<typeof SimilarClientMatch>;
